import axios from "axios";

const ATIVOS_URL =
  `${process.env.REACT_APP_API_URL}/evolucao_ativos` ||
  "http://localhost:3001/api/evolucao_ativos";


export async function getEvolucaoAtivos(token, estab) {
  const headers = {
    authorization: token,
  };

  let url = "";

  if (estab.length > 0)  {
    url = `${ATIVOS_URL}/${estab}`;
  } else {
    url = `${ATIVOS_URL}`;
  }

  const response = await axios.get(url, {
    headers,
  });

  return response.data;
}

